import moment from 'moment';

import { DispatcherDispatchRecord, DispatcherOrderRecord } from './dispatcher_types';

export type DispatcherOrderDispatchError = 'rescheduled';

/** Mirrors legacy Angular dispatcher-order `errors()` for cancel/reschedule card styling. */
export const orderDispatchError = (
  order: DispatcherOrderRecord,
  dispatch?: DispatcherDispatchRecord | null,
  undispatched = false,
): DispatcherOrderDispatchError | undefined => {
  if (undispatched && order.rescheduled && !dispatch) {
    return 'rescheduled';
  }

  if (dispatch?.arrival) {
    const arrival = moment(dispatch.arrival);
    const scheduled = moment(order.scheduled);

    if (!arrival.isSame(scheduled, 'day')) {
      return 'rescheduled';
    }
  }

  return undefined;
};
